/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import {
    ParentDiv,
    DesktopDiv,
    ImgIcon,
    ImgCont,
    ErrorMsgContainer,
    BottomCardDiv,
} from 'src/pages/reportUsage/procedure/components/unidSurgery/UnidSurgeryInfo.styled.jsx';
import { Title } from 'src/pages/reportUsage/procedure/components/Procedure.styled.jsx';
import {
    NoDataText,
    TitleComponent,
} from 'src/pages/reportUsage/utils/reportUsage.styled';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox.jsx';
import { InfoMainContainer } from 'src/pages/reportUsage/common/patientInformation/PatientInformation.styled';
import RadioButton from 'src/common/components/form/radioButton/RadioButton';
import Notes from 'src/common/components/notes';
import { sizes } from 'src/styles/Media.styled';
import InfoIcon from 'src/assets/images/InfoIcon.svg';
import NotImplantingAllUNiDRods from 'src/pages/reportUsage/procedure/components/unidSurgery/NotImplantingAllUNiDRods.jsx';
import { hideScrolling, resumeScrolling, isIpad, logErrorToConsole } from 'src/utils/util';
import WarningModal from 'src/pages/reportUsage/common/warningModal';
import MpxrConfirmationCard from 'src/pages/reportUsage/procedure/components/unidSurgery/mPXRConfirmationCard.jsx';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import { STORE_UNID_SURGERY_INFO } from 'src/pages/reportUsage/redux/action/types';
import { DARK_NAVY_FONT_COLOR, FONT_FAMILY_DEMI, SEMANTIC_TEXT_PX } from 'src/styles/fonts/MCFontConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const UnidSurgeryInfo = ({
    unidSurgeryInfo,
    setUnidSurgeryInfo,
    storedUnidSurgeryData,
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const charCountLimit = 250;
    const [textAreaCharLimit] = useState(charCountLimit);
    const [search] = useState(false);
    const [allSearch, setAllSearch] = useState(false);
    const [showReasonInDetail, setShowReasonInDetail] = useState(false);
    const [isValid] = useState(false);
    const [showMpxr, setShowMpxr] = useState(false);
    const [isConfirmationCheckboxChecked, setIsConfirmationCheckboxChecked] =
        useState(
            storedUnidSurgeryData?.mPXR ? storedUnidSurgeryData?.mPXR : false
        );

    const [showConfirmationCheckbox, setShowConfirmationCheckbox] = useState(
        storedUnidSurgeryData?.mPXR ? storedUnidSurgeryData?.mPXR : false
    );
    const usageDetails = useSelector(
        (state) => state.reportUsageRootReducer.usageDetails
    );

    const whyAllRodsNotImplanted = [
        {
            id: 1,
            label: t('procedure.unid.SurgeonChangedSurgicalPlan'),
            isChecked: false,
            reasonId: 'SurgeonChangedSurgicalPlan',
        },
        {
            id: 2,
            label: t('procedure.unid.IssuewithLengthorContour'),
            isChecked: false,
            reasonId: 'IssuewithLengthorContour',
        },
        {
            id: 3,
            label: t('procedure.unid.SalesOperations'),
            isChecked: false,
            reasonId: 'SalesOperations',
        },
        {
            id: 4,
            label: t('procedure.unid.ManufacturingIssue'),
            isChecked: false,
            reasonId: 'ManufacturingIssue',
        },
        {
            id: 5,
            label: t('procedure.unid.NotDeliveredonTime'),
            isChecked: false,
            reasonId: 'NotDeliveredonTime',
        },
        {
            id: 6,
            label: t('procedure.unid.MultipleVersionsOrdered'),
            isChecked: false,
            reasonId: 'MultipleVersionsOrdered',
        },
    ];

    // useDynatracePageName(pageNames.reportUsageUnidSurgeryInfo);

    useEffectWithErrorLogging(() => {
        if (showMpxr || search.showPopup) {
            hideScrolling();
        } else {
            resumeScrolling();
        }
    }, [showMpxr, search]);

    useEffectWithErrorLogging(() => {
        storedUnidSurgeryData?.whyAllRodsNotImplanted &&
            showMPXRConfirmationCard(
                storedUnidSurgeryData?.whyAllRodsNotImplanted
            );
        setUnidSurgeryInfo((prevState)=>({
            ...prevState,
            unidProducts: [
                {
                    description: '',
                    productCFN: 'None',
                    isChecked: true,
                },
            ],
            whyAllRodsNotImplanted:
                storedUnidSurgeryData?.whyAllRodsNotImplanted
                    ? storedUnidSurgeryData?.whyAllRodsNotImplanted
                    : whyAllRodsNotImplanted,
            reasonText: storedUnidSurgeryData?.reasonText
                ? storedUnidSurgeryData?.reasonText
                : '',
            mPXR: isConfirmationCheckboxChecked,
            mainRodCount: 0,
        }));
        dispatch({
            type: STORE_UNID_SURGERY_INFO,
            payload: {
                ...unidSurgeryInfo,
                unidProducts: [
                    {
                        description: '',
                        productCFN: 'None',
                        isChecked: true,
                    },
                ],
                whyAllRodsNotImplanted:
                    storedUnidSurgeryData?.whyAllRodsNotImplanted
                        ? storedUnidSurgeryData?.whyAllRodsNotImplanted
                        : whyAllRodsNotImplanted,
                reasonText: storedUnidSurgeryData?.reasonText
                    ? storedUnidSurgeryData?.reasonText
                    : '',
                mPXR: isConfirmationCheckboxChecked,
                mainRodCount: 0,
            },
        });
        const dataChecked =
            storedUnidSurgeryData?.whyAllRodsNotImplanted &&
            storedUnidSurgeryData?.whyAllRodsNotImplanted.some(
                (item) => item.isChecked
            );
        setShowReasonInDetail(dataChecked);
        // storedUnidSurgeryData?.whyAllRodsNotImplanted &&
        //     showMPXRConfirmationCard(
        //         storedUnidSurgeryData?.whyAllRodsNotImplanted
        //     );
    }, [usageDetails]);

    useEffectWithErrorLogging(() => {
        let body = document.getElementById('body');
        if (allSearch) {
            body.style.overflow = 'hidden';
        } else {
            body.style.overflow = '';
        }
    }, [allSearch]);

    // useEffectWithErrorLogging(() => {
    //     setUnidSurgeryInfo((prevState) => ({
    //         ...prevState,
    //         mPXR: isConfirmationCheckboxChecked,
    //     }));
    //     dispatch({
    //         type: STORE_UNID_SURGERY_INFO,
    //         payload: {
    //             ...unidSurgeryInfo,
    //             mPXR: isConfirmationCheckboxChecked,
    //         },
    //     });
    // }, [isConfirmationCheckboxChecked]);
    const confirmationChecked = (isCheckedValue) => {
        setIsConfirmationCheckboxChecked(isCheckedValue);
        setUnidSurgeryInfo((prevState) => ({
            ...prevState,
            mPXR: isCheckedValue,
        }));
        dispatch({
            type: STORE_UNID_SURGERY_INFO,
            payload: {
                ...unidSurgeryInfo,
                mPXR: isCheckedValue,
            },
        });
    };

    const updateReason = (ReasonInDetail) => {
        if (ReasonInDetail.length > charCountLimit) {
            const sliceLastIdx = charCountLimit - ReasonInDetail.length;
            ReasonInDetail = ReasonInDetail.slice(0, sliceLastIdx);
        }
        setUnidSurgeryInfo({ ...unidSurgeryInfo, reasonText: ReasonInDetail });
        dispatch({
            type: STORE_UNID_SURGERY_INFO,
            payload: { ...unidSurgeryInfo, reasonText: ReasonInDetail },
        });
    };

    const getModifiedData = (
        idx,
        type,
        label,
        productCFN,
        unidCounter,
        unidLineNumber,
        parentLineNumber
    ) => {
        if (type === 'all') {
            const modifiedData = unidSurgeryInfo.whyAllRodsNotImplanted.map(
                (data, index) => ({
                    ...data,
                    isChecked: idx === index,
                })
            );
            showMPXRConfirmationCard(modifiedData);

            setUnidSurgeryInfo((prevState) => ({
                ...prevState,
                whyAllRodsNotImplanted: modifiedData,
                reasonText: '',
            }));
            dispatch({
                type: STORE_UNID_SURGERY_INFO,
                payload: {
                    ...unidSurgeryInfo,
                    whyAllRodsNotImplanted: modifiedData,
                    reasonText: '',
                },
            });
            const dataChecked = modifiedData.some((item) => item.isChecked);
            setShowReasonInDetail(dataChecked);

            label === t('procedure.unid.IssuewithLengthorContour') ||
            label === t('procedure.unid.ManufacturingIssue')
                ? setShowMpxr(true)
                : setShowMpxr(false);
        }
    };

    const showMPXRConfirmationCard = (modifiedData) => {
        let reasonProvided = modifiedData.some((product) => {
            return (
                (product.label ==
                    t('procedure.unid.IssuewithLengthorContour') &&
                    product.isChecked) ||
                (product.label == t('procedure.unid.ManufacturingIssue') &&
                    product.isChecked)
            );
        });

        if (reasonProvided) {
            setShowConfirmationCheckbox(true);
        } else {
            setShowConfirmationCheckbox(false),
                // setIsConfirmationCheckboxChecked(false);
                confirmationChecked(false);
        }
    };

    return (
        <ParentDiv paddingBottom={'8rem'}>
            <TitleComponent paddingTop={'0px'}>
                {t('procedure.unidSurgeryInfo.unidSurgeryInfo')}
            </TitleComponent>

            <Box
                my={1}
                bgcolor={'#ffffff'}
                borderRadius={5}
                padding={
                    window.innerWidth <= sizes.mobileDevice
                        ? '20px 18px'
                        : '20px 22px 20px 22px'
                }
                width={'99.66%'}
                marginBottom={'24px'}
                border={isValid ? '1px solid #12C8F7' : ''}
                marginLeft={'1px'}
                marginRight={'1px'}
            >
                <Title fontSize={'16px'} color={'#140f4b'}>
                    <span>{t('procedure.unidSurgeryInfo.unidRodUse')}</span>
                    <span className="asterisk">*</span>
                </Title>
                <NoDataText
                    fontSize="12px"
                    color="#202124"
                    padding="0 0 20px 0"
                >
                    {t('procedure.unidSurgeryInfo.msg')}
                </NoDataText>

                <InfoMainContainer justifyContent={'flex-start'}>
                    <DesktopDiv isIpad={isIpad()}>
                        <div
                            style={{
                                margin:
                                    window.innerWidth <= sizes.mobileDevice
                                        ? '5px 0px'
                                        : '5px',

                                background: '#F5F5F5',
                                borderRadius: '6px',
                                padding: '10px',
                            }}
                        >
                            <Checkbox
                                checked={true}
                                label={t('procedure.unidSurgeryInfo.none')}
                                id="procedure-unidSurgeryInfo-none-checkbox"
                                margin={'0 0 6px 0px'}
                                labelStyleObj={{
                                    fontSize: SEMANTIC_TEXT_PX,
                                    fontFamily: FONT_FAMILY_DEMI,
                                    color: DARK_NAVY_FONT_COLOR,
                                    padding: '0 0 0 10px',
                                }}
                                background={'none'}
                                checkboxBorder={'1.5px solid #555555'}
                                alignItemDirection={'center'}
                                hoverEffect={'false'}
                                disableFocusEffect={'true'}
                            />
                        </div>
                    </DesktopDiv>
                </InfoMainContainer>

                {/* Deleted Item Popup */}

                {/* {Object.keys(alertPopup).length > 0 && alertPopup.show && (
                    <CancelAlertPopup
                        popupTitle={'UNiD Rod Not On Usage Form'}
                        alertMessage={
                            "You are attempting to add a UNiD Rod that wasn't entered during usage."
                        }
                        btn1Label={'Continue without adding to Usage'}
                        btn2Label={'Return to Usage Screen'}
                        btn1ClickHandler={continueWithoutAddingUsageHandler}
                        btn2ClickHandler={returnToUsageScreenClickHandler}
                        btnCloseClickHandler={continueWithoutAddingUsageHandler}
                        isInUnidSurgeryInfoPage
                        margin={'6px 0 0 0'}
                        isUnidInfo={true}
                        isDelayPositionChange={true}
                    />
                )} */}

                {/* MPXR warning Popup */}
                {showMpxr && (
                    <>
                        <WarningModal
                            message={t('procedure.unid.mPXRErrorMessage')}
                            onClose={() => {
                                try {
                                setShowMpxr(false);
                                setShowConfirmationCheckbox(true);
                                  } catch (error) {
                                     logErrorToConsole(error);
                                }
                            }}
                            title={t('procedure.unid.ComplaintReporting')}
                            modalContentHeight={'175px'}
                            paddingLeft={'8px'}
                        />
                    </>
                )}

                <InfoMainContainer>
                    <DesktopDiv isIpad={isIpad()}>
                        <BottomCardDiv isIpad={isIpad()}>
                            <Title
                                mbpaddingBtm={'10px'}
                                mbpaddingTop={'10px'}
                                paddingBtm={'10px'}
                                paddingTop={'10px'}
                                width={'100%'}
                                fontFamily={'AvenirNextWorld Demi'}
                                fontSize={'14px'}
                                color={'#202124'}
                            >
                                <span>
                                    {t('procedure.unidSurgeryInfo.mssg')}
                                </span>
                                <span className="asterisk">*</span>
                            </Title>

                            <ImgCont>
                                <ImgIcon
                                    id="procedure-unidSurgeryInfo-infoIcon"
                                    src={InfoIcon}
                                    onClick={() => setAllSearch(true)}
                                />
                            </ImgCont>
                        </BottomCardDiv>
                    </DesktopDiv>
                    <div
                        style={{
                            width:
                                window.innerWidth <= sizes.mobileDevice
                                    ? '100%'
                                    : '67.7%',
                        }}
                    >
                        {unidSurgeryInfo?.whyAllRodsNotImplanted?.length > 0
                            ? unidSurgeryInfo?.whyAllRodsNotImplanted?.map(
                                  (data, i) => (
                                      <DesktopDiv
                                          isIpad={isIpad()}
                                          desktopWidth={'50%'}
                                          desktopDisplay={'inline-table'}
                                          key={i}
                                      >
                                          <RadioButton
                                              isChecked={data.isChecked}
                                              label={data.label}
                                              handleChange={() =>
                                                  getModifiedData(
                                                      i,
                                                      t('procedure.unidSurgeryInfo.all'),
                                                      data.label,
                                                      data.productCFN,
                                                      data.unidCounter,
                                                      data.unidLineNumber,
                                                      data.parentLineNumber
                                                  )
                                              }
                                              fontFamilyStyle="AvenirNextWorld Regular"
                                              padding={'10px 0 10px 0'}
                                          />
                                          {data.isChecked &&
                                          (data.id == 2 || data.id == 4) &&
                                          !isConfirmationCheckboxChecked ? (
                                              <ErrorMsgContainer
                                                  isIpad={isIpad()}
                                              >
                                                  <AlertMsg
                                                      imageMargin={'0 6px 0 0'}
                                                      message={t(
                                                          'procedure.unid.mPXRErrorMessage'
                                                      )}
                                                  />
                                              </ErrorMsgContainer>
                                          ) : null}
                                      </DesktopDiv>
                                  )
                              )
                            : whyAllRodsNotImplanted.map((data, i) => (
                                  <DesktopDiv
                                      isIpad={isIpad()}
                                      desktopWidth={'50%'}
                                      desktopDisplay={'inline-table'}
                                      key={i}
                                  >
                                      <RadioButton
                                          isChecked={data.isChecked}
                                          label={data.label}
                                          handleChange={() =>
                                              getModifiedData(
                                                  i,
                                                  t('procedure.unidSurgeryInfo.all'),
                                                  data.label,
                                                  data.productCFN,
                                                  data.unidCounter,
                                                  data.unidLineNumber,
                                                  data.parentLineNumber
                                              )
                                          }
                                          fontFamilyStyle="AvenirNextWorld Regular"
                                          padding={'10px 0 10px 0'}
                                      />
                                      {data.isChecked &&
                                      (data.id == 2 || data.id == 4) &&
                                      !isConfirmationCheckboxChecked ? (
                                          <ErrorMsgContainer isIpad={isIpad()}>
                                              <AlertMsg
                                                  imageMargin={'0 6px 0 0'}
                                                  message={t(
                                                      'procedure.unid.mPXRErrorMessage'
                                                  )}
                                              />
                                          </ErrorMsgContainer>
                                      ) : null}
                                  </DesktopDiv>
                              ))}

                        {allSearch && (
                            <NotImplantingAllUNiDRods
                                onClose={() => setAllSearch(false)}
                            ></NotImplantingAllUNiDRods>
                        )}
                    </div>

                    <div
                        style={{
                            width:
                                window.innerWidth <= sizes.mobileDevice
                                    ? '100%'
                                    : '32.2%',
                        }}
                    >
                        {showReasonInDetail && (
                            <Notes
                                id="pricingNoteDivId"
                                showAstrisk={true}
                                note={
                                    unidSurgeryInfo.reasonText
                                        ? unidSurgeryInfo.reasonText
                                        : ''
                                }
                                updateNotes={updateReason}
                                maxLength={textAreaCharLimit}
                                placeholder={
                                    t('procedure.unidSurgeryInfo.UNiDrods')
                                }
                                title={
                                    window.innerWidth <= sizes.mobileDevice
                                        ? t('procedure.unidSurgeryInfo.ReasoninDetail')
                                        : t('procedure.unidSurgeryInfo.DetailedReason')
                                }
                                margin={
                                    window.innerWidth <= sizes.mobileDevice
                                        ? '10px 0 0 0'
                                        : '-33px 15px 0 0'
                                }
                                fontSize={'14px'}
                                helperText={`${
                                    charCountLimit -
                                        unidSurgeryInfo.reasonText?.length <
                                    0
                                        ? 0
                                        : charCountLimit -
                                          unidSurgeryInfo.reasonText?.length
                                } ${t('consignmentBilling.priceOverride.charactersRemainingLabel')}`}
                                justifyContent={'flex-end'}
                                boxShadow={'none'}
                                contentBodyMargin={'10px 0px 0px 3px'}
                                cardHeaderMargin={'14px 0px 0px 0px'}
                                cardFooterMargin={'2px 0px 24px 23px'}
                                // maxLength={textAreaCharLimit}
                                autoResize={false}
                                isScrollBar={true}
                                isTextAreaResize={false}
                                textAreaBorderRadius={'6px'}
                                placeholderFont={'11px'}
                                placeholderHeight={'100px'}
                                row={3}
                            />
                        )}
                    </div>
                </InfoMainContainer>

                {/* mpxr confirmation card */}
                {showConfirmationCheckbox && (
                    <MpxrConfirmationCard
                        isConfirmationCheckboxChecked={
                            isConfirmationCheckboxChecked
                        }
                        setIsConfirmationCheckboxChecked={confirmationChecked}
                    />
                )}
            </Box>
        </ParentDiv>
    );
};

export default UnidSurgeryInfo;
